import { render, staticRenderFns } from "./FarmTrialShowResultsEntry.vue?vue&type=template&id=960ff5b2"
import script from "./FarmTrialShowResultsEntry.vue?vue&type=script&lang=ts"
export * from "./FarmTrialShowResultsEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports